// extracted by mini-css-extract-plugin
export default {"qrCodeImage":"src-feature-config-subscription-plan-__billing-payment_qrCodeImage"};